import { AdalConfig, AuthenticationContext, adalFetch, withAdalLogin, adalGetToken } from 'react-adal';

import { EgUser } from '../../core/src/interfaces';

// import { httpInstance } from './core';
import * as http from './http';

console.log('adalConfig !!!');

export const adalConfig: AdalConfig = {
  tenant: process.env.REACT_APP_TENANT_ID,
  clientId: process.env.REACT_APP_CLIENT_ID || '',
  endpoints: {
    azure: 'https://graph.windows.net',
    office: 'https://graph.microsoft.com'
  },
  redirectUri: process.env.REACT_APP_REDIRECT_URI,
  postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI,
  cacheLocation: 'localStorage'
};



export const user = {
  id:        0,
  guid:     '',
  name:     '',
  role:     { id: 0 },
  account:  '',
  email:    '',
  testUser: ''
};



export const authContext = new AuthenticationContext(adalConfig);

export const withAdalLoginApi = (a: any, b: any, c: any) => {
  const x = withAdalLogin(authContext, 'https://graph.windows.net');
  const y = withAdalLogin(authContext, 'https://graph.microsoft.com');

  const w = x(a, b, c);

  return y(w, b, c);
};

export const loadAzureApi = async (route: string) => {
  let r = null;
  await adalFetch(authContext, 'https://graph.windows.net', fetch, 'https://graph.windows.net' + route + '?api-version=1.6', {})
  .then(res => res.json())
  .then(
    (result: any) => {
      r = result;
    },
    (error: any) => {
      r = error;
    }
  );
  return r;
};

export const loadOfficeApi = async (route: string) => {
  let r = null;
  await adalFetch(authContext, 'https://graph.microsoft.com', fetch, 'https://graph.microsoft.com' + route, {})
  .then(res => res.json())
  .then(
    (result: any) => {
      r = result;
    },
    (error: any) => {
      r = error;
    }
  );
  return r;
};

export const loadApi = async (route: string, method?: string, payload?: any, uploadFile?: boolean) => {
  let r = null;

  const headers = {
    'accept': 'application/json',
    'eg-user-id': user.guid
  };

  const options = {
    headers,
    method: 'get'
  };

  if (method) {
    options.method = method;

    if (payload) {
      if (uploadFile) {
        options['body'] = payload;
      } else {
        options.headers['content-type'] = 'application/json';
        options['body'] = JSON.stringify(payload);
      }
    }
  }

  await adalApiFetch(fetch, process.env.REACT_APP_WSP_API_BASE_URL + '/api' + route, options)
  .then(res => res.json())
  .then(
    (result: any) => {
      r = result;
    },
    (error: any) => {
      console.error(error);
      r = error;
    }
  );

  return r;
};



export const adalApiFetch = (fetch: any, url: string, options: any) => adalFetch(authContext, 'https://graph.windows.net', fetch, url, options);



export const loadCurrentUser = async (setCurrentUser: (p: any, e: any, t: any) => void) => {

  const currentUserResult = await http.get<{ currentUser?: EgUser, environments: any[], translations: any }>('/v2/users/current');

  if (currentUserResult && currentUserResult.currentUser) {

    // user

    user.id      = currentUserResult.currentUser.id ? currentUserResult.currentUser.id : 0;
    user.guid    = currentUserResult.currentUser.guid;
    user.name    = currentUserResult.currentUser.name;
    user.role    = currentUserResult.currentUser.role;
    user.account = currentUserResult.currentUser.account;

    const email = currentUserResult.currentUser.email || currentUserResult.currentUser.principalName;
    user.email = `${email}`.toLowerCase();



    // test account

    if (typeof currentUserResult.currentUser.testAccount !== 'undefined') {
      user.testUser = currentUserResult.currentUser.testAccount;
    }



    // current user context

    setCurrentUser(
      {
        id:       user.id,
        guid:     user.guid,
        email:    user.email,
        name:     user.name,
        role:     user.role,
        account:  user.account,
        testUser: user.testUser
      },
      currentUserResult.environments,
      currentUserResult.translations
    );

    return currentUserResult;

  } else {

    if (currentUserResult) {
      setCurrentUser(
        {
          id:        0,
          guid:     '',
          name:     '',
          role:     { id: 0 },
          account:  '',
          email:    '',
          testUser: ''
        },
        currentUserResult.environments,
        currentUserResult.translations
      );
    }

    return undefined;
  }
};



// httpInstance.interceptors.request.use(async (config: any) => {
//   // console.log('httpInstance.interceptor');

//   if (adalConfig && adalConfig.endpoints) {

//     try {
//       const msGraphToken = await adalGetToken(authContext, adalConfig.endpoints?.office);
//       config.headers['wsp-token'] = `Bearer ${msGraphToken}`;
//     } catch (error) {
//       // console.log(error);
//     }

//     try {
//       const azureGraphToken = await adalGetToken(authContext, adalConfig.endpoints?.azure);
//       config.headers['Authorization'] = `Bearer ${azureGraphToken}`;
//       config.headers['eg-user-id'] = user.guid;
//     } catch (error) {
//       // console.log(error);
//     }
//   }

//   return config;
// });



export const loadA365 = async (route: string, payload: any) => {

  const url = new URL(process.env.REACT_APP_WSP_API_BASE_URL + '/api/a365');

  const params = {
    route,
    payload: JSON.stringify(payload)
  };

  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

  return adalApiFetch(fetch, url.toString(), { headers: { 'eg-user-id': user.guid } }).then(res => res.json()).then(
    (result) => {
      if (result) {
        if (result && result.Data) {
          return result.Data;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    (error) => {
      console.error(error);
      return [];
    }
  );
};
